/**
 * HubSpot Integration Enums
 *
 * Enums used across the HubSpot integration entities
 */

/**
 * Setup Status Enum
 * Tracks the progress of the HubSpot integration wizard setup
 */
export enum HubSpotSetupStatus {
  CONNECTED = "CONNECTED",
  USERS_CONFIGURED = "USERS_CONFIGURED",
  COMPANIES_CONFIGURED = "COMPANIES_CONFIGURED",
  FIELDS_MAPPED = "FIELDS_MAPPED",
  COMPLETED = "COMPLETED",
}

/**
 * HubSpot sync job type (Ampersand push model).
 * Aligned with Salesforce SyncJobType for consistency; source (backfill/scheduled/live) goes in metadata.
 */
export enum HubSpotSyncJobType {
  USER_SYNC = "USER_SYNC",
  ACCOUNT_SYNC = "ACCOUNT_SYNC",
  CONTACT_SYNC = "CONTACT_SYNC",
}

/**
 * HubSpot sync log status.
 * Aligned with Salesforce SyncStatus (includes COMPLETED_WITH_ERRORS).
 */
export enum HubSpotSyncLogStatus {
  STARTED = "STARTED",
  COMPLETED = "COMPLETED",
  COMPLETED_WITH_ERRORS = "COMPLETED_WITH_ERRORS",
  FAILED = "FAILED",
  SKIPPED = "SKIPPED",
}
